<div class="hx-segmented-control-container">
  <div
    role="tablist"
    [attr.aria-label]="ariaLabel()"
    [class]="containerClasses().join(' ')"
    [ngStyle]="containerStyles()">
    @for (segment of validatedSegments(); track segment.key; let i = $index) {
      <button
        class="hx-segmented-control__segment"
        role="tab"
        type="button"
        [attr.aria-controls]="getContentId(segment.key)"
        [attr.aria-label]="segment.ariaLabel || segment.label"
        [attr.aria-selected]="internalSelectedKey() === segment.key"
        [attr.id]="getSegmentId(segment.key)"
        [class.hx-segmented-control__segment--disabled]="segment.disabled"
        [class.hx-segmented-control__segment--selected]="internalSelectedKey() === segment.key"
        [disabled]="segment.disabled"
        (click)="handleSegmentClick(segment)"
        (keydown)="handleSegmentKeydown($event, segment)">
        @if (segment.icon) {
          <hx-icon class="hx-segmented-control__icon" [svgIcon]="segment.icon" />
        }
        <span class="hx-segmented-control__label">{{ segment.label }}</span>
        @if (segment.badgeCount !== undefined && segment.badgeCount !== null) {
          <span class="hx-segmented-control__badge">{{ segment.badgeCount }}</span>
        }
      </button>
    }
  </div>

  <!-- Content area panels -->
  @if (showContent()) {
    <div class="hx-segmented-control__content" role="region" tabindex="0">
      @for (segment of validatedSegments(); track segment.key; let i = $index) {
        <hx-segment-body
          [attr.aria-labelledby]="getSegmentId(segment.key)"
          [attr.id]="getContentId(segment.key)"
          [content]="contentPortals()[i] ?? null"
          [isLoaded]="loadedSegmentKeys().has(segment.key)"
          [dynamicHeight]="dynamicHeight()"
          [position]="getSegmentPosition(i)" />
      }
    </div>
  }
</div>
